export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f72381a969ece8b976ee2729b9da0180b1cf7e190&name=fetchTypeahead!'